import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { me, logout as apiLogout, clearClubToken } from "./clubApi";
import TeamLogin from "./TeamLogin";
import TeamDashboard from "./TeamDashboard";
import { Btn, Card, Logo, Footer } from "./ui";

export default function TeamArea() {
  const location = useLocation();
  const [user, setUser] = useState(location.state?.user || null);
  const [state, setState] = useState(location.state?.user ? "ok" : "checking");

  useEffect(() => {
    if (location.state?.user) return;
    if (window.location.hash?.includes("session_id=")) return;
    me().then((u) => { setUser(u); setState("ok"); }).catch(() => setState("anon"));
  }, [location.state]);

  const doLogout = async () => {
    try { await apiLogout(); } catch { /* ignore */ }
    clearClubToken(); setUser(null); setState("anon");
  };

  if (state === "checking") return <div className="min-h-screen flex items-center justify-center"><div className="w-6 h-6 border-2 border-[#E5B13A] border-t-transparent rounded-full animate-spin" data-testid="team-loading" /></div>;
  if (state === "anon") return <TeamLogin />;
  if (user && user.role !== "admin" && user.role !== "incaricata") {
    return (
      <div className="mx-auto max-w-md px-6 pt-16" data-testid="team-pending">
        <div className="flex items-center gap-3"><Logo size={40} /><p className="font-club-display text-xl">Diamond Club</p></div>
        <Card className="mt-10">
          <p className="font-semibold">Ciao {user.name.split(" ")[0]}, il tuo accesso è in attesa.</p>
          <p className="mt-2 text-sm text-[#9A948A]">L'amministratore del Diamond Team deve approvare il tuo account{user.email ? ` (${user.email})` : ""}. Appena lo fa, qui trovi la tua dashboard.</p>
          <Btn variant="ghost" className="mt-5" onClick={doLogout} data-testid="pending-logout">Esci</Btn>
        </Card>
        <Footer />
      </div>
    );
  }
  return <TeamDashboard user={user} onUser={setUser} onLogout={doLogout} />;
}
